import React from 'react';
import PageNotFound from 'gatsby-rage-ppc-theme/src/gatsby-core-theme/components/atoms/not-found';

export default (props) => (
  <PageNotFound {...props} upcomingMatchesLink="/football/live-stream-providers" />
);
